import React from "react";

const RCDSStateContext = React.createContext(null);

export default RCDSStateContext;
